import React from "react";
import { Link } from "react-router-dom";
import MenuNav from "../components/Menunav";
import MobileMenu from "../components/MobileMenu";
import FaqSectionL from "../components/FaqSectionL";
import { Helmet } from "react-helmet";
import "./Navette.css";

export default function Navette() {
  return (
    <>
      <Helmet>
        <title>Navette avec Chauffeur | The Bridge of World</title>
        <meta name="description" content="Service de navette haut de gamme avec chauffeur. Réservez facilement en ligne pour vos trajets professionnels, familiaux ou touristiques." />
        <meta name="keywords" content="navette, chauffeur, transport, Togo, Afrique, voiture avec chauffeur, réservation navette" />
      </Helmet>

      <MenuNav />
      <MobileMenu />

<div
  className="navette-hero d-flex align-items-center justify-content-center text-white text-center"
  style={{ backgroundImage: "url('/images/navettehero.png')" }}
>
        <div className="container">
          <h1 className="fw-bold">🚐 Service Navette avec Chauffeur</h1>
          <p className="lead">Confort, sécurité et ponctualité pour tous vos trajets</p>
          <a
            href="https://wa.me/22878815494?text=Bonjour%2C+je+souhaite+r%C3%A9server+une+navette+avec+chauffeur"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-light btn-lg mt-3"
          >
            Réserver maintenant sur WhatsApp
          </a>
        </div>
      </div>

      <div className="container py-5">
        <h2 className="text-center fw-bold mb-4">Pourquoi choisir notre navette ?</h2>
        <div className="row text-center">
          <div className="col-md-4">
            <img src="/icons/driver.svg" alt="Chauffeur pro" width="60" className="mb-3" />
            <h5>Chauffeurs professionnels</h5>
            <p>Nos chauffeurs sont expérimentés, ponctuels et courtois.</p>
          </div>
          <div className="col-md-4">
            <img src="/icons/comfort.svg" alt="Confort" width="60" className="mb-3" />
            <h5>Confort garanti</h5>
            <p>Véhicules climatisés, propres et bien entretenus pour tous vos besoins.</p>
          </div>
          <div className="col-md-4">
            <img src="/icons/clock.svg" alt="Ponctualité" width="60" className="mb-3" />
            <h5>Disponible 7j/7</h5>
            <p>Service de navette disponible à tout moment, même en urgence.</p>
          </div>
        </div>
      </div>

      <div className="text-center py-5 bg-light">
        <h3 className="fw-bold mb-3">Vous avez un événement, un déplacement professionnel ou familial ?</h3>
        <p className="mb-4">Réservez votre navette en quelques clics. Nous nous occupons du reste !</p>
        <Link to="/reservation" className="btn btn-primary btn-lg">
          📅 Faire une demande
        </Link>
      </div>

      <FaqSectionL />
    </>
  );
}
